import styled from 'styled-components';
import { colors } from 'constants/colors';
import { BasicSectionContainer } from 'screens/style';
import { sectionBackgroundStyles } from 'screens/sectionBackgroundStyles';
import { styleSizes } from "constants/styleSizes";

export const FrequentlyAskedQuestionsScreenContainer = styled(BasicSectionContainer)`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  .background {
    ${sectionBackgroundStyles}
    @media (max-width: ${styleSizes.mobileBreakpoint}) {
        display: none;
      }
  }

  .content {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    column-gap: 20px;
    padding: 64px 0;
    @media (max-width: ${styleSizes.mobileBreakpoint}) {
      padding: 32px 0;
    }

    .title {
      width: 100%;
      font-size: 48px;
      text-align: center;
      font-weight: bold;
      color: ${colors.almostBlack};
      margin: 0 0 16px 0;
      line-height: 64px;
      @media (max-width: ${styleSizes.tabletBreakpoint}) {
        line-height: 48px;
        text-align: left;
      }
      @media (max-width: ${styleSizes.mobileBreakpoint}) {
        font-size: 32px;

      }
    }


    .subtitle {
      width: 100%;
      font-size: 32px;
      text-align: left;
      font-weight: bold;
      color: ${colors.almostBlack};
      margin: 64px 0 0 0;
      padding-bottom: 16px;
      border-bottom: 1px solid ${colors.signInBorderColor};
      @media (max-width: ${styleSizes.tabletBreakpoint}) {
        margin: 32px 0 0 0;
        border-bottom: 0;
        padding-bottom: 0;
      }
      @media (max-width: ${styleSizes.mobileBreakpoint}) {
      font-size: 28px;
      font-weight: 600;
    }

    }

    .questions {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      column-gap: 60px;
      margin: 8px 0 0 0;
      flex-direction: row;
      @media (max-width: ${styleSizes.tabletBreakpoint}) {
          flex-direction: column;
          margin: 0 0 16px 0;
        }
      .category {

        flex: 1;
        @media (max-width: ${styleSizes.tabletBreakpoint}) and (min-width: ${styleSizes.mobileBreakpoint}) {
          display: grid;
          grid-template-columns: 1fr 1fr; 
          gap: 0 16px;
        }
        .categoryTitle {
          grid-column: 1 / -1;
          width: 100%;
          font-size: 24px;
          text-align: left;
          font-weight: 600;
          color: ${colors.hoverBlue};
          margin: 32px 0;
          @media (max-width: ${styleSizes.tabletBreakpoint}) {
            padding-bottom: 24px;
            border-bottom: 1px solid ${colors.signInBorderColor};
            margin: 40px 0 0 0;
          }
          @media (max-width: ${styleSizes.mobileBreakpoint}) {
          font-weight: 700;
          }
        }

        p {
          width: 100%;
          font-size: 16px;
          text-align: left;
          font-weight: 400;
          color: ${colors.almostBlack};
          margin: 16px 0 0 0;
          line-height: 24px;

          .highLight {
            font-weight: bold;
            margin-bottom: 8px;
          }

          .link {
            margin-left: 5px;
            color: ${colors.hoverBlue};
            cursor: pointer;
            text-decoration: underline;
          }
        }
      }
    }

    p.ending {
      width: 100%;
      font-size: 16px;
      text-align: left;
      font-weight: 400;
      color: ${colors.black};
      margin: 48px 0 64px 0;
    }

    ul {
      margin: 0;
      padding-inline-start: 48px;

      li {
        width: 100%;
        font-size: 16px;
        text-align: left;
        font-weight: 400;
        color: ${colors.black};
        list-style-type: circle;
        margin: 16px 0 0 0;
        padding-right: 16px;


      }
    }
  }

  /* @media only screen and (min-width: 767px) and (max-width: 1200px) {

    .title {
      font-size: 30px;
    }

    .subtitle {
      font-size: 18px;
    }
  }

  @media only screen and (max-width: 767px) {

    .title {
      font-size: 24px;
    }

    .subtitle {
      font-size: 16px;
    }

    .description {
      font-size: 14px;
    }
  } */
`;